// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evaluation-modal {
  width: var(--evaluation-modal-width-tablet) !important;
}
@media (min-width: 1200px) {
  .evaluation-modal {
    width: var(--evaluation-modal-width-desktop) !important;
  }
}
.evaluation-modal__success {
  text-align: center;
  padding: 3rem;
  font-size: 1.4rem;
  color: var(--font-primary-colo);
}`, "",{"version":3,"sources":["webpack://./src/components/modals/EvaluationModal/EvaluationModal.scss"],"names":[],"mappings":"AAEA;EACI,sDAAA;AADJ;AAGI;EAHJ;IAIQ,uDAAA;EAAN;AACF;AAEI;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,+BAAA;AAAR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
